import React from 'react';

interface SkeletonProps {
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className }) => (
  <div className={`animate-pulse bg-slate-200 rounded-lg ${className}`} />
);

export const PostSkeleton = () => (
  <div className="bg-white border-y border-slate-200 pt-3 pb-4 space-y-4">
    <div className="px-4 flex items-center gap-3">
      <Skeleton className="w-10 h-10 rounded-full" />
      <div className="space-y-2">
        <Skeleton className="w-24 h-3" />
        <Skeleton className="w-32 h-2" />
      </div>
    </div>
    <div className="px-4 space-y-2">
      <Skeleton className="w-full h-3" />
      <Skeleton className="w-2/3 h-3" />
    </div>
    <Skeleton className="w-full aspect-video" />
    <div className="px-4 flex justify-between">
      <Skeleton className="w-20 h-4" />
      <Skeleton className="w-20 h-4" />
    </div>
  </div>
);

export const ProfileSkeleton = () => (
  <div className="flex flex-col w-full bg-zinc-50 min-h-screen">
    <div className="bg-white px-4 pt-6 pb-6 shadow-sm space-y-6">
      <div className="flex justify-between">
        <Skeleton className="w-20 h-20 rounded-3xl" />
        <div className="flex gap-2">
          <Skeleton className="w-10 h-10 rounded-xl" />
          <Skeleton className="w-24 h-10 rounded-xl" />
        </div>
      </div>
      <div className="space-y-2">
        <Skeleton className="w-32 h-6" />
        <Skeleton className="w-20 h-3" />
      </div>
      <Skeleton className="w-full h-12 rounded-2xl" />
      <div className="grid grid-cols-4 gap-2">
        {[1, 2, 3, 4].map(i => <Skeleton key={i} className="h-16 rounded-2xl" />)}
      </div>
    </div>
    <div className="px-4 pt-6 grid grid-cols-3 gap-1">
      {[1, 2, 3, 4, 5, 6].map(i => <Skeleton key={i} className="aspect-[9/16] rounded-xl" />)}
    </div>
  </div>
);

export const LongVideoSkeleton = () => (
  <div className="flex flex-col w-full bg-white min-h-screen space-y-4">
    <Skeleton className="w-full aspect-video" />
    <div className="p-5 space-y-4">
      <Skeleton className="w-3/4 h-6" />
      <div className="flex items-center gap-3">
        <Skeleton className="w-11 h-11 rounded-2xl" />
        <div className="space-y-2">
          <Skeleton className="w-24 h-3" />
          <Skeleton className="w-16 h-2" />
        </div>
      </div>
    </div>
    <div className="p-4 space-y-4">
      {[1, 2, 3].map(i => (
        <div key={i} className="flex gap-4">
          <Skeleton className="w-32 h-20 rounded-[1.5rem]" />
          <div className="flex-1 space-y-2 py-2">
            <Skeleton className="w-full h-4" />
            <Skeleton className="w-2/3 h-3" />
          </div>
        </div>
      ))}
    </div>
  </div>
);
